import { GoArrowRight } from "react-icons/go";

export default function Header() {
  return (
  <section id="home" className="bg-white min-h-[calc(100vh-70px)] snap-start">
      <div className="grid max-w-screen-xl px-4 py-8 mx-auto lg:gap-8 xl:gap-0 lg:py-16 lg:grid-cols-12">
        <div className="mr-auto place-self-center lg:col-span-7">
          <p className="max-w-2xl md:text-lg lg:text-xl font-bold text-sky-800">
            Hello, I am
          </p>
          <h1 className="max-w-2xl mb-4 text-4xl font-extrabold tracking-tight leading-none md:text-5xl xl:text-6xl">
            Happy Lakudzala
          </h1>
          <p className="max-w-2xl mb-6 lg:mb-8 text-2xl font-bold ">
            A Professional{" "}
            <span id="textElement" className="text-sky-800"></span>
          </p>
          <a
            href="#contact"
            className="inline-flex items-center justify-center px-5 py-3 mr-3 text-base font-medium text-center text-white rounded-full bg-sky-800 hover:bg-sky-900 focus:ring-4 focus:ring-sky-300"
          >
            Contact Me
            <GoArrowRight className="w-5 h-5 ml-2 -mr-1" />
          </a>
        </div>
        <div className="lg:mt-0 lg:col-span-5 rounded-full border">
          <img
            src="/img/iamhq_no-bg.png"
            alt="header-image"
            className="rounded-full"
          />
        </div>
      </div>
    </section>
  );
}
